import styled from 'styled-components';
import { rem } from 'polished';

export const Title = styled.h1<{ marginTop?: number; marginBottom?: number }>`
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  font-size: ${rem(24)};
  line-height: ${rem(28)};
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(56)};
  margin-top: ${({ marginTop }) =>
    marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(28)};
    margin: 0;
    margin-top: ${({ marginTop }) =>
      marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};
    margin-bottom: ${({ marginBottom }) =>
      marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(32)};
  `}
`;
